



import React, { useState } from "react";
import CompanyPerformance from "./CompanyPerformance";
import DepartmentPerformance from "./DepartmentPerformance";
import CompanyDailyPerformance from "./CompanyDailyPerformance";
import WorkerDailyPerformance from "./WorkerDailyPerformance";
import ScheduleCompliance from "./ScheduleCompliance";

const Reports = () => {
  // Shared date range state
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });

  return (
    <>
      {/* Pass both dateRange and onDateChange to sync filters */}
      <CompanyPerformance
        dateRange={dateRange}
        onDateChange={(range) => setDateRange(range)}
      />

      <DepartmentPerformance dateRange={dateRange} />

      <CompanyDailyPerformance  dateRange={dateRange} />
      <WorkerDailyPerformance dateRange={dateRange} />
      <ScheduleCompliance  dateRange={dateRange}/>
    </>
  );
};

export default Reports;
